/** Мост tactical-workspace → MapLibre heatmap layer. */

export const TACTICAL_HEATMAP_EVENT = "tacticalHeatmapOverlay";

export type TacticalHeatmapOverlayDetail = {
  featureCollection: GeoJSON.FeatureCollection | null;
};

export function dispatchTacticalHeatmapOverlay(
  featureCollection: GeoJSON.FeatureCollection | null,
): void {
  window.dispatchEvent(
    new CustomEvent<TacticalHeatmapOverlayDetail>(TACTICAL_HEATMAP_EVENT, {
      detail: { featureCollection },
    }),
  );
}
